import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from '../pages/Login';
import ProtectedRoute from './ProtectedRoute';
import ChangePasswordPage from '../pages/changepass';
import DashboardOverview from '../pages/DashboardOverview';
import Settings from '../pages/Settings';
import Unauthorized from '../pages/Unauthorized';
import Upload from '../pages/Upload';
import { OAuthRedirect } from '../pages/OAuthRedirect';
import EcommerceDashboard from '../pages/EcommerceDashboard';
import ECommerceMarketingPage from '../pages/Ecomm-Marketing';
import ECommerceSalesPage from '../pages/Ecomm-Sales';
import ECommerceCustomerPage from '../pages/Ecomm-Customer';
import WholesaleMarketingPage from '../pages/Wholesale-Marketing';
import WholesaleSalesPage from '../pages/Wholesale-Sales';
import WholesaleCustomerPage from '../pages/Wholesale-Customer';
import WholesaleDashboard from '../pages/WholesaleDashboard';
import RetailDashboard from '../pages/RetailDashboard';
import RetailCustomerPage from '../pages/Retail-Customer';
import RetailMarketingPage from '../pages/Retail-Marketing';
import RetailSalesPage from '../pages/Retail-Sales';
import KeyEventsPage from '../pages/KeyEvents';

export const AppRoutes: React.FC = () => {




  return (
    <div className="flex h-screen">
      

      <main className="flex flex-col flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="/oauth-redirect" element={<OAuthRedirect />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="/overview"
            element={
              <ProtectedRoute allowedGroups={['admin', "executive", "wholesale", "ecommerce", "retail"]}>
                <DashboardOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ecommerce"
            element={
              <ProtectedRoute allowedGroups={['admin','executive', 'ecommerce']}>
                <EcommerceDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retail"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'retail']}>
                <RetailDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ecomm-marketing"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'ecommerce']}>
                <ECommerceMarketingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ecomm-sales"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'ecommerce']}>
                <ECommerceSalesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ecomm-customer"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'ecommerce']}>
                <ECommerceCustomerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wholesale"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'wholesale']}>
                <WholesaleDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wholesale-marketing"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'wholesale']}>
                <WholesaleMarketingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wholesale-sales"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'wholesale']}>
                <WholesaleSalesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wholesale-customer"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'wholesale']}>
                <WholesaleCustomerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retail-marketing"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'retail']}>
                <RetailMarketingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retail-sales"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'retail']}>
                <RetailSalesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retail-customer"
            element={
              <ProtectedRoute allowedGroups={['admin', 'executive', 'retail']}>
                <RetailCustomerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/key-events"
            element={
              <ProtectedRoute allowedGroups={['admin', "executive", "wholesale", "ecommerce", "retail"]}>
                <KeyEventsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <ProtectedRoute allowedGroups={['admin','executive']}>
                <Upload />
              </ProtectedRoute>
            }
          /> 
          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedGroups={['admin','executive']}>
                <Settings />
              </ProtectedRoute>
            }
          />        
        </Routes>
      </main>
    </div>
  );
};

export default AppRoutes;
